module.exports = __webpack_public_path__ + "img/8.2c8a2c8f.png";